import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";

import {
    CURRENT_MONTH,
    CUSTOM_DATE,
    LAST_12_MONTHS,
    LAST_28_DAYS,
    LAST_30_DAYS,
    LAST_3_MONTHS,
    LAST_6_MONTHS,
    LAST_7_DAYS,
    LAST_90_DAYS,
    LAST_CALENDAR_YEAR,
    LAST_MONTH,
    LAST_YEAR,
    settingsOverviewSelectOptions,
} from "../constants/DatePickerSelectOptions";
import moment from "moment";
import { CUSTOM } from "../constants/OptionsConstants";

export const useDateFilterEngagementOverview = () => {
    const [searchParams, setSearchParams] = useSearchParams();

    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [months, setMonths] = useState(null);

    const initialDateStart = moment().utc().startOf("month")
    const initialDateEnd = moment().utc().endOf("day")


    const handleOptionSelect = (value) => {
        if (!value) {
            return
        }
        let startDate = new Date();
        let endDate = new Date();

        switch (value.value) {
            case LAST_7_DAYS:
                startDate = moment().subtract(6, "days").startOf("day");
                endDate = moment().endOf("day");
                break;
            case LAST_28_DAYS:
                startDate = moment().subtract(27, "days").startOf("day");
                endDate = moment().endOf("day");
                break;
            case LAST_30_DAYS:
                startDate = moment().subtract(29, "days").startOf("day");
                endDate = moment().endOf("day");
                break;
            case LAST_90_DAYS:
                startDate = moment().subtract(89, "days").startOf("day");
                endDate = moment().endOf("day");
                break;
            case LAST_12_MONTHS:
                startDate = moment().subtract(12, "months").startOf("day");
                endDate = moment().endOf("day");
                break;
            case LAST_CALENDAR_YEAR:
                startDate = moment().subtract(1, "year").startOf("year");
                endDate = moment().subtract(1, "year").endOf("year");
                break;
            case CURRENT_MONTH:
                startDate = moment().startOf("month");
                endDate = moment().endOf("day");
                break;
            case LAST_MONTH:
                startDate = moment().subtract(1, "month").startOf("month");
                endDate = moment().subtract(1, "month").endOf("month");
                break;
            case LAST_3_MONTHS:
                startDate = moment().subtract(3, "month").startOf("month");
                endDate = moment().subtract(1, "month").endOf("month");
                break;
            case LAST_6_MONTHS:
                startDate = moment().subtract(6, "month").startOf("month");
                endDate = moment().subtract(1, "month").endOf("month");
                break;
            case LAST_YEAR:
                startDate = moment()
                    .subtract(1, "year")
                    .subtract(1, "month")
                    .startOf("month");
                endDate = moment().subtract(1, "month").endOf("month");
                break;
            default:
            case CUSTOM_DATE:
                startDate = moment(startDate).startOf("day")
                endDate = moment(endDate).endOf("day")
                break;
        }

        setSearchParams((prev) => {
            prev.set("date_type", value.value);
            prev.set("start_date", startDate.toISOString());
            prev.set("end_date", endDate.toISOString());
            return prev;
        });

        setStartDate(startDate.toDate());
        setEndDate(endDate.toDate());
        setMonths(value);
    };

    useEffect(() => {
        const dateType = searchParams.get("date_type");

        if (dateType) {
            const found = settingsOverviewSelectOptions.find((item) => item.value === dateType);

            if (!found) {
                setStartDate(initialDateStart.toISOString());
                setEndDate(initialDateEnd.toISOString());
                setMonths({ value: LAST_MONTH, label: "Last month" });
            }

            if (found?.value === CUSTOM_DATE) {
                const start = searchParams.get("start_date");
                const end = searchParams.get("end_date");
                if (start && end) {
                    setStartDate(moment(start).toDate());
                    setMonths({ value: CUSTOM_DATE, label: CUSTOM });

                    if (end === "null") {
                        setEndDate(null);
                    } else {
                        setEndDate(moment(end).toDate());
                    }
                }
            } else {
                handleOptionSelect(found);
            }

        }
        else {
            setStartDate(initialDateStart.toISOString());
            setEndDate(initialDateEnd.toISOString());
            setMonths({ value: LAST_MONTH, label: "Last month" });
        }
    }, []);

    return {
        startDate,
        endDate,
        months,
        setStartDate,
        setEndDate,
        setMonths,
        handleOptionSelect,
    };
};
